import Container from "olive-react-myoneui/lib/Container";

function CourseBundleDescription({className, courseBundleDescTitle, courseBundleDesc}) {

  return (
    <div className={`${className || ""} bundle-courses-description p-0`}>
      <h4 className="fw-bold">{courseBundleDescTitle}</h4>
      {courseBundleDesc && <p>{courseBundleDesc}</p>}
    </div>
  );
}

export default CourseBundleDescription;
